import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";

export interface AddressesPageStyles {
    page?: MobiusPageProps;
    quickLinksGridItem?: GridItemProps;
    mainSectionGridItem?: GridItemProps;
}
export const addressesPageStyles: AddressesPageStyles = {
    page: {
        css: css`
        div[data-test-selector="hiddenAddressActions"] {
            position: relative;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        > div > div > div > div:first-child {
                            padding-left: 0;
                            padding-right: 0;
                        }                            
                    `,
                    css`                        
                        div[data-test-selector="createAddressButtonContainer"] > div {
                            margin: 0.625rem 0 1.5625rem;
                            width: 100%;
                        }
                    `,
                    null,
                ],
                "min",
            )
        };
     

        @media screen and (max-width: 1279px) {
            > div > div > div > div:first-child {
                max-width: 100% !important;
                flex-basis: 100% !important;
                background: transparent !important;
                box-shadow: none !important;
            }
            > div > div > div > div:last-child {
                max-width: 100%;
                flex-basis: 100%;
            }
             
        }
        @media screen and (max-width:992px) {
            div[data-test-selector="createAddressButtonContainer"] > div {
                margin: 0.625rem 0 1.25rem;
                width: 100%;
            }
        }
        @media screen and (min-width: 990px) and (max-width: 1199px) {
            > div > div > div > div:first-child {
                max-width: 100%;
                flex-basis: 100%;
            }
        }
        @media screen and (min-width: 990px) and (max-width: 1279px) {
            > div > div > div > div:first-child {
                padding-bottom: 0;
            }
        }
            
        `,
    },
    quickLinksGridItem: { 
        width: [12, 12, 12, 2, 2],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        null,
                        css`
                            background: ${themeColors.colorWhite};
                            padding-left: 0;
                            padding-right: 0;
                            box-shadow: 0.125rem 0 0.25rem 0 rgba(0,37,84,0.05);
                        `,
                        css`
                            max-width: 17rem;
                            flex-basis: 17rem;
                        `,
                        null,
                    ],
                    "min",
                )
            };
            @media screen and (max-width: 1279px) {
                max-width: 100% !important;
                flex-basis: 100% !important;
                background: transparent !important;
                box-shadow: none !important; 
            }
            @media screen and (min-width: 990px) and (max-width: 1199px) {
                max-width: 100%;
                flex-basis: 100%;
            }
            @media screen and (min-width: 990px) and (max-width: 1279px) {
                padding-bottom: 0;
            }
        `,
     },
    mainSectionGridItem: { 
        width: [12, 12, 12, 10, 10],
        css: css`
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        null,
                        css`
                            margin-bottom: 8.75rem !important;
                        `,
                        css`
                            max-width: calc(100% - 17.5rem);
                            flex-basis: calc(100% - 17.5rem);
                            padding-left: 1.5625rem;
                        `,
                        null,
                    ],
                    "min",
                )
            };
            @media screen and (min-width: 990px) and (max-width: 1199px) {
                max-width: 100%;
                flex-basis: 100%;
            }
            @media screen and (max-width: 1279px) {
                max-width: 100% !important;
                flex-basis: 100% !important;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [   
                        null,
                        null, 
                        css`
                            padding-bottom: 0.625rem;
                            margin-bottom: 7.5rem !important;
                            > div {
                                > div {
                                    > div {
                                        > div {
                                            flex-basis: 100%;
                                            max-width: 100%;
                                            padding-top: 0.625rem;
                                            padding-bottom: 0.625rem;
                                            &:last-child {
                                                order: -1;
                                                flex-basis: 100%;
                                                max-width: 100%;
                                            }
                                            &:nth-last-child(2) {
                                                padding-bottom: 1.25rem;
                                                flex-basis: 100%;
                                                max-width: 100%;
                                            }
                                        }
                                        
                                    }
                                }
                            }
                        `,
                        null,
                    ],
                    "max",
                )
            };
        `,
    },
};
const styles = addressesPageStyles;

const mapStateToProps = (state: ApplicationState) => {
    const addressFieldsDataView = getAddressFieldsDataView(state);
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);
    return {
        currentBillToState: getCurrentBillToState(state),
        currentShipToState: getCurrentShipToState(state),
        shouldLoadAddressFields: !addressFieldsDataView.value && !addressFieldsDataView.isLoading,
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    loadCurrentBillTo,
    loadCurrentShipTo,
    loadAddressFields,
    loadCurrentCountries,
};

type Props = PageProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class AddressesPage extends React.Component<Props> {
    UNSAFE_componentWillMount() {
        const {
            currentBillToState,
            currentShipToState,
            shouldLoadAddressFields,
            shouldLoadCountries,
            loadCurrentBillTo,
            loadCurrentShipTo,
            loadAddressFields,
            loadCurrentCountries,
        } = this.props;

        if (!currentBillToState.value && !currentBillToState.isLoading) {
            loadCurrentBillTo();
        }
        if (!currentShipToState.value && !currentShipToState.isLoading) {
            loadCurrentShipTo();
        }
        if (shouldLoadAddressFields) {
            loadAddressFields();
        }
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
    }
    render() {
        return (
            <Page {...styles.page} data-test-selector="addressPage">
                 <GridContainer>
                    <GridItem {...styles.quickLinksGridItem}>
                        <Zone contentId={this.props.id} zoneName="NavigationList" />
                    </GridItem>
                    <GridItem {...styles.mainSectionGridItem}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                    </GridItem>
                </GridContainer>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AddressesPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "AddressesPage" instead of this constant.
 */
export const AddressesPageContext = "AddressesPage";
